import { Suspense } from 'react';
import React from 'react';
import AptorAdminModule from './AptorAdminModule';

const AptorAdminModuleProxy = () => (
  <Suspense fallback={<div/>}>
    <AptorAdminModule />
  </Suspense>
);

export default AptorAdminModuleProxy;